import { Department, DepartmentResponse } from "../coworkerApiCalls/Department/DepartmentsTypes";

const serviceResponseToService = (service: DepartmentResponse): Department => {
    return {
      id: service.id,
      name: service.name,
    };
  };

const serviceResponsesToServices = (services: DepartmentResponse[]): Department[] => {
    return services.map((service: DepartmentResponse): Department => serviceResponseToService(service));
};
  
export { serviceResponseToService, serviceResponsesToServices };